import { deserializeListData } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { orbitalTrackCompleteDetachDetailSchema } from '@src/deserialize/yup/orbitalTrack'
import graphql from '@src/graphql/query/getDetachDetail'
import {
  OrbitalTrackCompleteDetachDetail,
  OrbitalTrackDetachDetailInputParams
} from '@src/types/orbitalTrack'
import { useCallback, useState } from 'react'

const useGetDetachDetail = (): Hook => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<OrbitalTrackCompleteDetachDetail[]>([])

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const variables = {
        input: request
      }

      const response = await query({
        variables
      })

      const tracks = deserializeListData<OrbitalTrackCompleteDetachDetail>(
        response,
        orbitalTrackCompleteDetachDetailSchema
      )

      setData(tracks)

      return {
        data: tracks
      }
    },
    [query]
  )

  return {
    data,
    fetch,
    loading
  }
}

type Request = OrbitalTrackDetachDetailInputParams[]

type Response = {
  data: OrbitalTrackCompleteDetachDetail[]
}

type Hook = {
  data: OrbitalTrackCompleteDetachDetail[]
  fetch: (request: Request) => Promise<Response>
  loading: boolean
}

export default useGetDetachDetail
